const StatusRekomendasi ={
    DRAFT_PERMOHONAN : 'Draft Permohonan',
    MENUNGGU_DI_PROSES : 'Menunggu Di Proses',
    PEMOHONAN_DI_PROSES : 'Pemohonan Di Proses',
    VALIDASI_PEMOHONAN : 'Verifikasi Teknis',
    VALIDASI_PEMOHONAN_SELESAI : 'Validasi Pemohonan Selesai',
    VALIDASI_PEMOHONAN_DITOLAK : 'Validasi Pemohonan Ditolak',
    TELAAH_TEKNIS_SELESAI : 'Telaah Teknis Selesai',
    TELAAH_TEKNIS_DITOLAK : 'Telaah Teknis Ditolak',
    MENUNGGU_PROSES_DRAFT_SK : 'Menunggu Proses Draft SK',
    PEMBUATAN_DRAFT_SK : 'Pembuatan Telaah dan Draft SK',
    DRAFT_SK_TANDA_TANGAN_DIREKTUR : 'Menunggu Draft SK Tanda Tangan Direktur',
    SK_REKOMENDASI_B3 : 'SK Rekomendasi B3',
    MENGIRIM_SK_REKOMENDASI_B3_KE_SPIONAM : 'Mengirim SK Rekomendasi B3 Ke SPIONAM',
    SELESAI : 'Selesai',
    DITOLAK : 'Ditolak',
  };
  
  export default StatusRekomendasi;
  